import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Pings the backend on every route change so visits are logged.
 * No personal data is sent — the backend hashes IP + UA + date for anonymous unique counts.
 * Admin paths are excluded so David's own usage doesn't pollute analytics.
 */
export default function useTrackPageView() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return;
    // Fire-and-forget; never block UI or surface errors
    api.post("/analytics/view", { path, referrer: document.referrer || "" }).catch(() => {});
  }, [location.pathname]);
}
